// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import ReactPlayer from 'react-player'
import StarRatingComponent from 'react-star-rating-component';

//Import helpers
import { tokenize, bytesToString } from '../../../../helper';

// Import components
import LogoutButton from '../../../../components/reusables/logout';
import LoadingSpinner from '../../../reusables/spinner';

// Styling
import './VideoPlayer.css';
import { FaArrowLeft, FaAngleRight, FaAngleDoubleRight, FaAngleLeft, FaAngleDoubleLeft } from 'react-icons/fa'; // FaStar removed

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const VIDEO_API_URL = API_URL + '/video';
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            loadingVideos: true,
            videos: [],
            total: 0,
            page: 1,
            last_page: 1,
            per_page: 0,
            typing: false,
            typingTimeout: 0,
            query: '',
            searching: false,
            searchResults: [],
            searchPagination: {
                page: 1,
                total: 0,
                per_page: 25,
                total_pages: 0
            },
            showSearchResults: false,
            showDownloadLinks: false,
            error: false,
            errorCode: '',
            errorMessage: '',
            mediaStarted: false,
            mediaWatched: 0,
            rating: 0,
            ratingExists: false,
            fullViewThreshold: '',
            fullViewSubmitted: false,
        }
    }

    componentDidUpdate = () => {
        window.onpopstate = (e) => {


            if (this.state.selected) {
                this.setState({ selected: false });
                window.location.href = '/videos';
            }

        }
    }

    getVideos = () => {
        // make a request to the back-end for videos
        this.setState({ loadingVideos: true })
        console.log(`${VIDEO_API_URL}/?page=${this.state.page}`)

        axios.get(`${VIDEO_API_URL}/?page=${this.state.page}`, tokenize())
            .then(response => {
                // console.log(response.data);

                if (response.data.success) {
                    var payload = response.data.videos;
                    console.log(payload)

                    this.setState({
                        loadingVideos: false,
                        videos: payload.data,
                        total: payload.total,
                        page: payload.page,
                        last_page: Math.ceil(payload.total / payload.per_page),
                        per_page: payload.per_page
                    });
                } else {
                    if (response.data.portfolioNotFound) {
                        console.log("Portolio not found")
                        this.setState({ error: true, errorCode: 'V1', errorMessage: 'Issue loading videos. Please log out and login again. If issues persists call OLLI at (949) 451-1403.' })
                    }
                }

            })
            .catch(error => {
                console.log(error);
                this.setState({ error: true });
            })
    }

    fetchFullViewThreshold = () => {
        axios.get(`${SETTINGS_URL}/analytics/threshold`, tokenize())
            .then(response => {
                var payload = response.data;

                if (payload.success) {
                    this.setState({ fullViewThreshold: payload.threshold.percentage })
                }
            })
            .catch(error => {

            })
    }

    createPartialView = () => {
        console.log("CREATE PARTIAL VIEW")
        var view_info = { video_uri: this.state.selected.uri.slice(8), title: this.state.selected.name, view: 0 };
        axios.post(`${VIDEO_API_URL}/partial-view`, tokenize({ view_info }))
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            })
    }

    createFullView = () => {
        console.log("CREATING FULL VIEW")
        var view_info = { video_uri: this.state.selected.uri.slice(8), title: this.state.selected.name, view: 1 };
        axios.post(`${VIDEO_API_URL}/full-view`, tokenize({ view_info }))
            .then(response => {
                console.log(response)
                this.setState({ fullViewSubmitted: true })
            })
            .catch(error => {
                console.log(error);
            })
    }

    getPercentage = (watched, duration) => {
        return Math.floor((watched / duration) * 100);
    }


    onProgress = (e) => {
        // if we have passed an hour of watch time
        // mark as a full view
        var watched = this.state.mediaWatched + 1;
        var duration = this.state.selected.duration;
        var threshold = this.state.fullViewThreshold;

        var percentage = this.getPercentage(watched, duration);
        this.setState({ mediaWatched: watched })
        // console.log("Duration: ", duration)
        // console.log("Threshold: ", threshold)
        // console.log("Watched: ", watched)
        // console.log("percentage:", percentage)
        if (percentage === threshold) {
            // we have watched for a percentage of the total
            // create full view
            var user_type = cookie.get('user-type');
            if (user_type !== 'admin' && !this.state.fullViewSubmitted) {
                this.createFullView();
            }
        }
    }

    onStart = (e) => {
        this.setState({ fullViewSubmitted: false })
        var user_type = cookie.get('user-type');
        if (user_type !== 'admin') {
            this.createPartialView();
        }
    }

    componentDidMount = () => {
        // When the component (page) loads, do the following:

        // Verify the token from the cookie (if exists)
        var token = cookie.get('token');
        if (token) {
            // Success, load the videos
            this.fetchFullViewThreshold();
            this.getVideos();
        } else {
            // Faiure, send them back to the welcome page
            window.location.href = '/';
        }


        // Set an onClick listener
        document.addEventListener('mousedown', this._handleClick, false);
        document.addEventListener('keypress', this._handleKeyPress, false)
    }

    _handleClick = (event) => {
        // If a mouse click is outside the search bar, the search results should collapse
        if ((this.searchArea && this.searchArea.contains(event.target)) || (this.resultVideos && this.resultVideos.contains(event.target))) {
            // console.log('inside');

            this.setState({ showSearchResults: true });

        } else if (this.searchArea) {
            // console.log('outside');

            if ((event.clientX + 7) >= event.target.clientWidth) {

            } else {
                this.setState({ showSearchResults: false });
            }
        }
    }

    _handleKeyPress = (event) => {
        // Listen for the enter key pressed

        if (event.keyCode === 13 && this.state.showSearchResults) {
            // Enter key was pressed
            console.log("Enter key pressed");
            this.searchNow();
        }
    }

    selectVideo = (type, index) => {
        // Set the video player in focus,

        if (type === 'listed') {
            // If it's a selected video
            console.log(this.state.videos[index])
            this.setState({
                selected: this.state.videos[index]
            }, () => {
                this.checkRatingExists()
            })
        } else {
            // It's a video from the search results
            this.setState({
                selected: this.state.searchResults[index],
                showSearchResults: false
            })
        }

    }

    resetVideo = () => {
        // Set the video player out of focus
        this.setState({ selected: null, showDownloadLinks: false });
    }

    updatePage = (action) => {
        // Given an action determine which page number should be requested from back-end

        var self = this;
        return new Promise(function (resolve, reject) {
            var newPage = self.state.page;
            switch (action) {
                case 'first':
                    newPage = 1;
                    break;
                case 'last':
                    newPage = self.state.last_page;
                    break;
                case 'forward':
                    newPage += 1;
                    break;
                case 'back':
                    newPage -= 1;
                    break;
                default:
                    break;
            }
            if (newPage !== self.state.page && newPage > 0 && newPage <= self.state.last_page) {
                // Requested page is valid
                resolve(newPage);
            } else {
                // Page number is out of range, send back the current page
                reject(self.state.page);
            }
        });
    }

    handlePageSelection = (action) => {
        // When the user requests a new page, determine what type of action to perform

        this.updatePage(action)
            .then(newPage => {
                // console.log('Page to be rendered: ', newPage);
                this.setState({ page: newPage });
                this.fetchFullViewThreshold();
                this.getVideos();
            })
            .catch(currentPage => {
                // console.log('Don\'t render another page');
            })

    }

    handleSearchPagination = (action) => {
        // Go forward or back in search results

        console.log(action)
        var searchPagination = this.state.searchPagination;

        if (action === 'forward') {
            searchPagination.page += 1;
            setTimeout(() => this.setState({ searchPagination }), 10);

        } else if (action === 'back') {
            searchPagination.page -= 1;
            setTimeout(() => this.setState({ searchPagination }), 10);
        }

        setTimeout(this.searchNow(), 25);

    }

    searchInputDetected = (event) => {
        var self = this;
        var newQuery = event.target.value;

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        var searchPagination = this.state.searchPagination;
        searchPagination.page = 1;

        // Seach after .75 seconds since last character typed
        this.setState({
            query: newQuery,
            typing: false,
            searchPagination,
            typingTimeout: setTimeout(function () {
                self.searchNow();
            }, 750)
        });
    }

    searchNow = () => {
        // After the timeout, query the back-end for videos
        // console.log('Search now: ', query);
        var query = this.state.query;
        var page = this.state.searchPagination.page;

        if (query !== '') {
            this.setState({ searching: true });

            axios.get(`${VIDEO_API_URL}/search?query=${query}&page=${page}`, tokenize())
                .then(response => {
                    // console.log(response.data);
                    var payload = response.data;
                    var { total, page, per_page } = payload.videos;
                    var searchPagination = this.state.searchPagination;
                    searchPagination.total = total;
                    searchPagination.page = page;
                    searchPagination.per_page = per_page;
                    searchPagination.total_pages = Math.ceil(total / per_page);
                    console.log(payload);
                    this.setState({ searchResults: payload.videos.data, searching: false, searchPagination });
                })
                .catch(error => {
                    console.log(error);
                })
        } else {
            // If they cleared the search box, the results should away
            this.setState({ searchResults: [] });
        }

    }

    toggleShowDownloads = () => {
        this.setState({ showDownloadLinks: !this.state.showDownloadLinks });
    }

    renderAdminControl = () => {
        var user_type = cookie.get('user-type');
        return (user_type === 'admin') ? <button style={{ marginLeft: '0.5em', marginRight: '0.5em' }} className='btn btn-primary' onClick={() => window.location.href = '/admin/history'}>Back to Admin</button> : ''
    }

    renderDownloadControl = () => {
        var user_type = cookie.get('user-type');
        return (user_type === 'admin') ? <p id='downloadButton' onClick={this.toggleShowDownloads} >Admin Download</p> : ''
    }



    checkRatingExists = () => {
        axios.get(`${VIDEO_API_URL}/rating-exist?video_uri=${this.state.selected.uri.slice(8)}`, tokenize())
            .then(response => {
                if (response.data.success) {
                    if (response.data.result.length > 0) {
                        // Get the actual rating
                        console.log(response.data.result[0].rating);
                        this.setState({ ratingExists: true, rating: response.data.result[0].rating });
                    } else {
                        this.setState({ ratingExists: false, rating: 0 });
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    setRating = (rating) => {
        var rating_info = { video_uri: this.state.selected.uri.slice(8), rating: rating };
        axios.post(`${VIDEO_API_URL}/create-rating`, tokenize({ rating_info }))
            .then(response => {
                this.setState({ ratingExists: true, rating: rating })
            })
            .catch(error => {
                console.log(error);
            })
    }

    updateRating = (rating) => {
        var rating_info = { video_uri: this.state.selected.uri.slice(8), rating: rating };
        axios.post(`${VIDEO_API_URL}/update-rating`, tokenize({ rating_info }))
            .then(response => {
                this.setState({ ratingExists: true, rating: rating })
            })
            .catch(error => {
                console.log(error);
            })
    }

    onStarClick(nextValue, prevValue, name) {
        this.setState({ rating: nextValue });
        if (this.state.ratingExists) {
            // update rating
            this.updateRating(nextValue);
        } else {
            this.setRating(nextValue);
        }
    }


    renderNavbar = () => {
        return (
            <div id='navbarContainer' className='container-fluid'>
                <nav id='video-navbar' className={(this.state.showSearchResults === false) ? `navbar navbar-light bg-light justify-content-between extraNavbarPadding rounded overflow-hidden shadow-sm mb-4` : `navbar navbar-light bg-light justify-content-between rounded overflow-hidden shadow-sm mb-4`}>
                    <div className="form-inline">
                        <input
                            ref={searchArea => this.searchArea = searchArea}
                            className={(this.state.error) ? "form-control mt-2 ml-0 mb-2 mr-2 disabled" : "form-control mt-2 ml-0 mb-2 mr-2"}
                            type="search"
                            placeholder="Search"
                            aria-label="Search"
                            value={this.state.query}
                            onChange={this.searchInputDetected}
                        />
                        <button className='btn btn-secondary m-2' onClick={() => window.location.href = '/'}>Live Stream Schedule</button>
                    </div>
                    <div>
                        <button className='btn btn-danger m-2' onClick={() => window.location.href = '/live'}>View OLLI Classroom Live TV</button>
                    </div>
                    <div className="ml-2 my-2">
                        {this.renderAdminControl()}
                        <LogoutButton />
                    </div>
                </nav>

                {this.renderSearchResults()}

            </div>
        );
    }

    renderSearchResults = () => {
        // Render the search results

        if (this.state.showSearchResults) {
            if (this.state.searching) {
                return <div id='searchPaginationContainer' className='searchResult'><LoadingSpinner message='Searching..' /></div>
            } else {
                var searchResults = this.state.searchResults;
                var { total, page, total_pages } = this.state.searchPagination;

                return (
                    <div ref={resultVideos => this.resultVideos = resultVideos} id='searchResults'>
                        {searchResults.map((video, index) => {
                            var imageLink = video.pictures.searchThumbnail.link;
                            return (
                                <div key={index} className='searchResult' onClick={() => this.selectVideo('search', index)}>
                                    <div><img alt={video.name} src={imageLink} /></div>
                                    <div><h4>{video.name}</h4></div>
                                </div>
                            )
                        })}
                        <div id='searchPaginationContainer' className='searchResult'>
                            <p>Found {total} related recordings. </p>

                            {(searchResults.length === 0) ?
                                ''
                                :
                                <span>
                                    {
                                        (page > 1) ?
                                            <FaAngleLeft size='2.5em' onClick={() => this.handleSearchPagination('back')} />
                                            :
                                            ''
                                    }

                                    <p>&nbsp;Page {page}/{total_pages}</p>
                                    {
                                        (page < total_pages) ?
                                            <FaAngleRight size='2.5em' onClick={() => this.handleSearchPagination('forward')} />
                                            :
                                            ''
                                    }


                                </span>
                            }


                        </div>
                    </div>
                );
            }
        } else {
            return '';
        }
    }

    render() {

        // Determine if there is a selected video to render
        if (this.state.error) {
            return (
                <div>
                    {this.renderNavbar()}
                    <div className='alert alert-danger'>
                        <p>{this.state.errorMessage}</p>
                        <h4 className='text-center'>Error Code: {this.state.errorCode}</h4>
                    </div>
                </div>

            )
        }
        else if (this.state.loadingVideos) {
            return (
                <div className='container-fluid'>
                    <LoadingSpinner message='Loading videos..' />
                </div>

            )
        }
        else if (!this.state.selected) {
            // Render the video list
            return (
                <div className='container-fluid'>
                    {this.renderNavbar()}
                    {

                        (!this.state.showSearchResults) ?
                            <div className='videoContainer'>
                                {this.state.videos.map((video, index) => {
                                    var imageLink = video.pictures.listingThumbnail.link;
                                    return (
                                        <div key={index} className='card videoBox' onClick={() => this.selectVideo('listed', index)}>
                                            <img alt={video.name} src={imageLink} />
                                            <h3>{video.name}</h3>
                                        </div>
                                    );
                                })}

                                <div className='paginationContainer'>

                                    <div>
                                        {(this.state.loadingVideos) ?
                                            'Loading...'
                                            :
                                            <div>
                                                <FaAngleDoubleLeft size='2em' onClick={() => this.handlePageSelection('first')} />
                                                <FaAngleLeft size='2em' onClick={() => this.handlePageSelection('back')} />
                                                {this.state.page} / {this.state.last_page}
                                                <FaAngleRight size='2em' onClick={() => this.handlePageSelection('forward')} />
                                                <FaAngleDoubleRight size='2em' onClick={() => this.handlePageSelection('last')} />
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>

                            :
                            ''

                    }
                </div>
            )
        } else {
            // Render the video player
            var videoId = this.state.selected.uri.slice(7);
            return (
                <div className='container-fluid' id='playerContainer'>
                    {this.renderNavbar()}
                    <div className='card' id='playerBox'>
                        <ReactPlayer className="mx-auto" url={`https://player.vimeo.com/video${videoId}`} controls={true} frameBorder="0" onProgress={this.onProgress} onStart={this.onStart} />
                        <h2>{this.state.selected.name}</h2>

                        <div id='buttonGroup'>
                            <button className='btn btn-secondary' onClick={this.resetVideo}><FaArrowLeft size='2em' /> Back</button>
                            <div>
                                <StarRatingComponent
                                    name="videoRating"
                                    starCount={5}
                                    value={this.state.rating}
                                    onStarClick={this.onStarClick.bind(this)}
                                />
                            </div>
                            <div>
                                {this.renderDownloadControl()}
                            </div>
                        </div>

                        {(this.state.showDownloadLinks) ?
                            <div id='downloadLinkContainer'>
                                {this.state.selected.download.map((downloadItem, index) => {
                                    return (<div key={index}><a href={downloadItem.link}>{downloadItem.quality} {downloadItem.width}x{downloadItem.height} ({bytesToString(downloadItem.size)})</a></div>);
                                })}
                            </div>
                            :
                            <div className='container-fluid' id='playerContainer'></div>
                        }
                    </div>
                </div>
            );
        }
    }
}


export default VideoPlayer;